import React, { useState, useEffect, } from 'react'
import { useDispatch } from 'react-redux';
import { setOpenLoader, setTitleLoader } from '../../../config/redux/actions';
import "../../../assets/styles/login.scss"
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AuthService from '../../../services/auth';
import { simpleAlerts } from "../../../utils/alerts";
import { clearBrowserCache } from '../../../utils/function';
import { CODES } from "../../../utils/codesHTTP";
import { Global } from '../../../config/general';
import { toast } from 'react-toastify';

const Login = ({ setUserInfo, }) => {
    const info = Global.info;
    const infoTime = Global.infoTime;

    const dispatch = useDispatch();
    const handleOpenLoader = (value) => dispatch(setOpenLoader(value));
    const handleTitleLoader = (value) => dispatch(setTitleLoader(value));

    const [usuario, setUsuario] = useState(null);
  
    useEffect(() => {
        handleOpenLoader(false);
    }, [])

    const handleSubmit = async (event) => {
        event.preventDefault();
        handleOpenLoader(true);
        handleTitleLoader('Validando ...');
        try {
            const data = new FormData(event.currentTarget);
            data.append("sistema", 'runasst');
            const result = await AuthService.signIn(data);
            if (result?.status === CODES.SUCCESS_200) {
                const expirationDate = new Date(new Date().getTime() + result?.data?.expires_in * 1000);
                localStorage.setItem(infoTime, expirationDate);
                localStorage.setItem(info, JSON.stringify(result?.data));
                setUserInfo(result?.data);
                clearBrowserCache()
            }  else if (result === undefined) {
                toast.error("¡Error: El servidor no está disponible, comuníquese con TI!", {
                    theme: "colored"
                });
            }else if (result.data.recovery === true) {
                const { message, detalle } = result.data;
                toast.warning(
                    <div>
                        <strong>{message}</strong>
                        {detalle && <div style={{ marginTop: '5px' }}>{detalle}</div>}
                    </div>,
                    {
                        theme: "dark",
                        autoClose: 6000
                    }
                );
            } else {
                toast.error(result.data.message, { theme: "colored" });
            }
            return [];
        } catch (error) {
            console.log(`Error en signIn: ${error}`);
        } finally {
            handleOpenLoader(false);
            handleTitleLoader(null);
        }
    };

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleRecuperarContraseña = async () => {
        if (usuario === '' || !usuario || !isNaN(usuario)) {
            simpleAlerts({message:'Debe ingresar un usuario valido'}, 'warning');
            return;
        }

        handleOpenLoader(true);
        handleTitleLoader('Solicitando cambio de contraseña');
        try {
            const result = await AuthService.recoveryPassword(usuario);
            if (result.status === CODES.SUCCESS_200) {
                simpleAlerts({message:result.data.message}, 'success');
            } else {
                simpleAlerts({message:result?.response?.data?.message} || 'Error al solicitar', 'error', 'colored');
            }
            return [];
        } catch (error) {
            console.log(`handleRecuperarContraseña: ${error}`);
        } finally {
            handleOpenLoader(false);
            handleTitleLoader(null);
        }
    };

    return (
      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-wrap">
          <h2>RunaSST</h2>
          <div className="profile-image-container">
            <img
              src={`${process.env.PUBLIC_URL}/icon.png`}
              alt="Profile"
              className="profile-image"
            />
          </div>
          <div className="form-login">
            <input type="text" name="usuario" placeholder="Username" required  value={usuario || ''} onChange={(event) => setUsuario(event.target.value)} />
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                required
              />
              <a
                className="toggle-password btn-sm"
                onClick={togglePasswordVisibility}
                style={{ color: "white" }}
              >
                {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </a>
            </div>
            <button type="submit">Sign in</button>
          </div>
          <div
            style={{ marginTop: "12px", textAlign: "center", fontSize: "13px" }}
          >
            <span style={{ color: "#ccc" }}>¿Problemas con tu contraseña?</span>
            <br />
            <button
              type="button"
              onClick={handleRecuperarContraseña}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "#00BFFF",
                textDecoration: "underline",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Recuperar contraseña
            </button>
          </div>
        </div>
      </form>
    );
}

export default Login